import { render } from "./WithdrawPasswordModal.vue?vue&type=template&id=b86246d4"
import script from "./WithdrawPasswordModal.vue?vue&type=script&lang=js"
export * from "./WithdrawPasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__